// extracted by mini-css-extract-plugin
export default {"brandsWrapper":"Brands_brandsWrapper__fu2LC","headingWrapper":"Brands_headingWrapper__DZo59","relatedArticleLink":"Brands_relatedArticleLink__k0MNB"};